export default "/fonts/poppins-v9-latin-700.eot?cdf90dba3593d39f61d394b42b2eab52";